const opsManagement = {
    path: 'opsManagement',
    name: 'opsManagement',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'opsManagement',
        icon: 'HSIconfont hs-icon-a-ic_oam_normal4',
        showRealm: ['SYSTEM']
    },
    children: [
        {
            path: 'custHappAp',
            name: 'custHappAp',
            component: () => import('@/views/custHappAp'),
            meta: { code: 'opsManagement:apMapping' }
        },
        {
            path: 'custHummerManagement',
            name: 'custHummerManagement',
            component: () => import('@/views/custHummerManagement'),
            meta: { code: 'opsManagement:hummer' }
        },
    ]
};

export default opsManagement;
